import { render, staticRenderFns } from "./entregasCedis.vue?vue&type=template&id=769e6bcf&"
import script from "./entregasCedis.vue?vue&type=script&lang=js&"
export * from "./entregasCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports